import {
  Alert,
  Button,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import moment from "moment";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import CustomDialog from "../../../commons/dialog/customDialog";
import { StyledDialog } from "../../../styled/dialog";
import HistorialTrasladosTable from "./historialTrasladosTable";

const HistorialTrasladosDialog = ({
  open,
  onClose,
  accident,
  data,
  loading,
}) => {
  const traslados = data?.traslados ?? (Array.isArray(data) ? data : []);
  const cantTraslados = data?.cantTraslados ?? traslados.length;
  const valorUmbral = data?.valorUmbralCantTraslados;

  return (
    <CustomDialog open={open} onClose={onClose} fullWidth maxWidth="lg" dismissible>
      <DialogTitle>
        Traslados anteriores
        {accident?.siniestro ? ` — Siniestro ${accident.siniestro}` : ""}
      </DialogTitle>
      <DialogContent>
        {accident && (
          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="body2">
              <strong>
                {accident.apellidoTrabajador}, {accident.nombreTrabajador}
              </strong>
              {accident.documento ? ` · Documento ${accident.documento}` : ""}
              {accident.fechaHoraAccidente
                ? ` · Accidente ${moment(accident.fechaHoraAccidente).format("DD/MM/YYYY")}`
                : ""}
            </Typography>
          </Alert>
        )}

        {loading ? (
          <StyledDialog.LoadingContainer>
            <CircularLoading />
          </StyledDialog.LoadingContainer>
        ) : traslados.length === 0 ? (
          <Typography>No hay traslados anteriores para este siniestro.</Typography>
        ) : (
          <>
            <HistorialTrasladosTable data={traslados} loading={loading} />
            {valorUmbral != null && (
              <Alert severity="warning" sx={{ mt: 2 }}>
                Este siniestro acumula <strong>{cantTraslados}</strong> traslado(s).
                El umbral configurado en Traslados_TiposAlarma.ValorUmbral para
                CANT_TRASLADOS es <strong>{valorUmbral}</strong>.
              </Alert>
            )}
          </>
        )}
      </DialogContent>
      {!loading && (
        <StyledDialog.Actions>
          <Button onClick={onClose} color="primary" variant="contained">
            Cerrar
          </Button>
        </StyledDialog.Actions>
      )}
    </CustomDialog>
  );
};

export default HistorialTrasladosDialog;
